import styled, { css } from "styled-components";

import { colors, radii } from "shared/ui/tokens";

const NARROW = "599px";

export const Bar = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    padding: 14px 20px;

    @media (max-width: ${NARROW}) {
        padding: 10px 12px;
        flex-wrap: nowrap;
    }
`;

export const Summary = styled.div`
    flex: 1 1 auto;
    min-width: 0;
    font-size: 14px;
    color: ${colors.textSecondary};

    @media (max-width: ${NARROW}) {
        font-size: 13px;
    }
`;

export const Controls = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

const control = css`
    height: 40px;
    border-radius: ${radii.base};
    font-family: inherit;
    font-size: 0.875rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const Arrow = styled.button`
    ${control}
    width: 40px;
    flex: none;
    border: 1px solid ${colors.fieldBorder};
    background: ${colors.surface};
    color: rgba(0, 0, 0, 0.7);

    svg {
        font-size: 18px;
    }

    &:disabled {
        color: rgba(0, 0, 0, 0.3);
        cursor: not-allowed;
    }
`;

export const PageButton = styled.button<{ $active: boolean }>`
    ${control}
    min-width: 40px;
    padding: 0 10px;
    border: 1px solid ${({ $active }) => ($active ? colors.primary : colors.fieldBorder)};
    background: ${({ $active }) => ($active ? colors.primary : colors.surface)};
    color: ${({ $active }) => ($active ? "#fff" : "rgba(0,0,0,0.7)")};

    @media (max-width: ${NARROW}) {
        display: none;
    }
`;

export const Gap = styled.span`
    min-width: 20px;
    text-align: center;
    color: ${colors.textSecondary};

    @media (max-width: ${NARROW}) {
        display: none;
    }
`;

// На узком вьюпорте номера страниц заменяются счётчиком: одиннадцать кнопок в 390px
// не помещаются, а прокрутка подвала таблицы вбок читается как поломка.
export const Compact = styled.span`
    display: none;
    padding: 0 4px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.7);
    white-space: nowrap;

    @media (max-width: ${NARROW}) {
        display: inline;
    }
`;
